/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";
import dynamic from "next/dynamic";
import { IMediaModel } from "@nf/common";
import { useMediaParentalRatingGuard } from "../../hooks";
import type { IMediaDetailsBottomContentProps } from "../../components";
import type { IMediaDetailsScreenProps } from "../MediaDetailsScreen";

const MediaDetailsScreen = dynamic<IMediaDetailsScreenProps>(() =>
  import("../MediaDetailsScreen").then((mod) => mod.MediaDetailsScreen)
);

const MediaDetailsBottomContent = dynamic<IMediaDetailsBottomContentProps>(() =>
  import("components/Media/MediaDetailsBottomContent").then(
    (mod) => mod.MediaDetailsBottomContent
  )
);

export type MediaDetailsScreenProps = {
  media?: IMediaModel;
  extraMaterials?: IMediaModel[];
  relatedMaterials?: IMediaModel[];
};

export const MovieDetailsScreen = ({
  media,
  extraMaterials,
  relatedMaterials,
}: MediaDetailsScreenProps) => {
  useMediaParentalRatingGuard(media);

  return (
    <MediaDetailsScreen media={media}>
      {media && (
        <>
          <MediaDetailsBottomContent
            media={media}
            extraMaterials={extraMaterials}
            relatedMaterials={relatedMaterials}
          />
        </>
      )}
    </MediaDetailsScreen>
  );
};

export default MovieDetailsScreen;
